import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2ItemDiff } from '@/api/model/interfaces';

export default class PackageKS2ItemDiffOdata extends OdataManager<PackageKS2ItemDiff> {}
